export default "__VITE_ASSET__2aRH42TO__"